<main>
    <div class="header-text" *ngIf="!viewAttendence">
        Student Event Registration and Attendance
    </div>


    <div *ngIf="viewAttendence">
        <div class="d-flex gap-3 align-items-center" style="cursor: pointer; margin-bottom: 1rem;" (click)="goBack()">
            <div style="cursor: pointer; display: flex; align-items: center;">
                <img class="action-button" src="assets/images/Buttons/left-chevron.svg" alt="left" />
            </div>
            <div class="view-header-text">
                Back
            </div>
        </div>
    </div>

    <div class="table-card" *ngIf="!viewAttendence">
        <app-table [columns]="columns" [data]="data" [actionTemplate]="actionButtonsTemplate" [loading]="loading">
        </app-table>
    </div>


    <div class="table-card" *ngIf="viewAttendence">
        <app-table [columns]="attenColumns" [data]="attenData" [actionTemplate]="action2ButtonsTemplate"
            [loading]="loading">
        </app-table>
    </div>

</main>

<ng-template #actionButtons let-row>
    <div style="display: flex; gap: 0.8rem; justify-content: center;">
        <button class="view-button" (click)="onView(row)">View Details</button>
    </div>
</ng-template>
<ng-template #actionButtons2 let-student>
    <button [ngClass]="student.attendanceStatus === 'Present' ? 'status-inactive' : 'status-active'"
        (click)="onToggleAttendance(student)">
        {{ student.attendanceStatus === 'Present' ? 'Mark Absent' : 'Mark Present' }}
    </button>
</ng-template>